(function () {
  var posted = /[?&]customer_posted=true/.test(location.search);
  var header = document.getElementById('site-header');
  var toggle = header && header.querySelector('.nav-toggle');
  var hero = document.getElementById('hero');
  var bar = document.getElementById('wl-sticky');

  /* mobile nav */
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    header.querySelectorAll('.nav-links a').forEach(function (a) {
      a.addEventListener('click', function () { header.classList.remove('nav-open'); });
    });
  }

  /* "Join waitlist" buttons: scroll to the hero form and focus the email field */
  document.querySelectorAll('[data-wl-jump]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var target = document.getElementById('hero-form');
      if (!target) return; // not on homepage — let the link navigate
      e.preventDefault();
      if (header) header.classList.remove('nav-open');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = target.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
    });
  });

  /* light analytics hook: fires into dataLayer if you add GA4/GTM later */
  document.querySelectorAll('.wl-form').forEach(function (f) {
    f.addEventListener('submit', function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'waitlist_submit', location: f.getAttribute('data-location') || 'unknown' });
    });
  });

  /* sticky bar */
  if (!bar) return;
  var dismissed = false;
  try { dismissed = sessionStorage.getItem('pc_wl_dismissed') === '1'; } catch (e) {}
  if (posted || dismissed) return;

  var visibleForms = new Set();
  var threshold = function () { return hero ? hero.offsetHeight * 0.6 : 420; };

  function update() {
    var show = visibleForms.size === 0 && window.scrollY > threshold();
    bar.classList.toggle('is-visible', show);
    if (show) document.body.classList.add('has-sticky');
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) visibleForms.add(en.target); else visibleForms.delete(en.target);
      });
      update();
    }, { threshold: 0.35 });
    document.querySelectorAll('.wl-form').forEach(function (f) {
      if (!bar.contains(f)) io.observe(f);
    });
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();

  var dismiss = bar.querySelector('[data-wl-dismiss]');
  if (dismiss) dismiss.addEventListener('click', function () {
    bar.classList.remove('is-visible');
    document.body.classList.remove('has-sticky');
    try { sessionStorage.setItem('pc_wl_dismissed', '1'); } catch (e) {}
    window.removeEventListener('scroll', update);
  });
})();
